export default function isDocument(element) {
  return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}


//////////////////
// WEBPACK FOOTER
// ../~/dom-helpers/esm/isDocument.js
// module id = 2595
// module chunks = 121